import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const abortUrlSelector = createSelector(
    entryDataSelector,
    (entryData): string | undefined => entryData.links?.find(link => link.id === "abortUrl")?.value,
)

export default abortUrlSelector
